<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :options="optionCustomer"
                        :customLabel="customerLabel"
                        :show-labels="false"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id">
                    </multiselect> &nbsp;&nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.sale"
                        :options="OptionSeller"
                        :customLabel="customSaleLabel"
                        :show-labels="false"
                        placeholder="ค้นหา Sale"
                        track-by="sale_id">
                    </multiselect> &nbsp;&nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.area"
                        @input="getProvince(search.area)"
                        :options="optionGeography"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกภาค"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-if="search.area"
                        class="form-control select"
                        v-model="search.province"
                        @input="getDistricts(search.province)"
                        :options="optionProvince"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกจังหวัด"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-if="search.province && search.area"
                        class="form-control select"
                        v-model="search.district"
                        :options="optionDistricts"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกเขต / อำเภอ"
                        track-by="id">
                    </multiselect>
                    <button @click="onClickSearch(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printTransportFoamCustomer"
                            type="button">
                        <icon name="search"></icon>
                        พิมพ์ค่าขนส่งลูกค้าย่อย
                    </button>
                    &nbsp;
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="showUpdateModal"
                            type="button">
                        อัพเดทค่าขนส่ง
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>ชื่อเซลล์</th>
                    <th>ชื่อลูกค้า</th>
                    <th>จังหวัด</th>
                    <th colspan="3">เหมา</th>
                    <th colspan="3">ห่อเล็ก</th>
                    <th colspan="3">ห่อใหญ่</th>
                    <th colspan="3">พ่วง(ห่อเล็ก)</th>
                    <th colspan="3">พ่วง(ห่อใหญ่)</th>
                    <th rowspan="2">แก้ไข</th>
                </tr>
                <tr>
                    <th colspan="3"></th>
                    <template v-for="i in 5">
                        <template v-for="data in transport_type">
                            <th>{{ data.name }}</th>
                        </template>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in transportFoamList">
                    <td>{{ data.customer.sale ? data.customer.sale.sale_id : '' }}
                        {{ data.customer.sale ? data.customer.sale.name : '' }}
                    </td>
                    <td>{{ data.customer_id }} {{ data.store_name }}</td>
                    <td>{{ data.customer.province ? data.customer.province.name : '' }}</td>
                    <template v-if="data.transport_form1.length > 0">
                        <template v-for="(transport,index) in data.transport_form1">
                            <td v-if="transport.transport_type_id != 4">{{ transport.price }}</td>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="i in 5">
                            <template v-for="j in transport_type">
                                <td></td>
                            </template>
                        </template>
                    </template>
                    <td>
                        <a @click="showCustomerData(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="transportFoamList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="onClickSearch(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <br>
        <b-modal size="lg" hide-footer hide-header ref="edit_sub_transport_fee">
            <edit-transport-foam-modal @submit="saveTransportFoam">
            </edit-transport-foam-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal size="lg" hide-header hide-footer ref="update_price_modal">
            <div class="text-center">
                <h2>อัพเดทค่าขนส่ง</h2>
                <h6 class="text-left">*สามารถอัพเดทค่าขนส่งทั้งหมดได้(เฉพาะลูกค้าที่มีค่าขนส่งอยู่แล้ว)</h6>
                <h6 class="text-left">*เพิ่มใส่จำนวน(100)</h6>
                <h6 class="text-left">*ลดใส่จำนวนลบ(-100)</h6>
                <b-row>
                    <b-col sm="3"></b-col>
                    <b-col sm="3">รถใหญ่</b-col>
                    <b-col sm="3">รถใหญ่ (รถบริษัท)</b-col>
                    <b-col sm="3">รถเล็ก (กระบะ)</b-col>
                </b-row>
                <b-row v-for="(x,i1) in update_date" class="mb-3">
                    <b-col sm="3" class="col text-right">
                        <label>{{ static_transport_list[i1 - 1] }}</label>
                    </b-col>
                    <b-col sm="3" v-for="(y,i2) in x">
                        <b-input v-model="update_list[i1][i2]"></b-input>
                    </b-col>
                </b-row>
            </div>
            <br/>
            <div class="col text-center">
                <button @click="submitUpdate"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button @click="hideUpdateModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import EditTransportFoamModal from "./EditSubTransportFoamModal";
import Loading from "../../Utility/Loading";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";

export default {
    name: "TransportFoamList",
    components: {Loading, EditTransportFoamModal, VuePagination, Multiselect},
    data() {
        return {
            transportFoamList: [],
            status_loading: 1,
            msg: '',
            optionCustomer: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            search: {
                customer: null,
                sale: null,
                area: null,
                province: null,
                district: null,
            },
            update_date: {
                1: {1: '', 2: '', 3: ''},
                2: {1: '', 2: '', 3: ''},
                3: {1: '', 2: '', 3: ''},
                4: {1: '', 2: '', 3: ''},
                5: {1: '', 2: '', 3: ''},
            },
            static_transport_list: ['เหมา', 'ห่อเล็ก', 'ห่อใหญ่', 'พ่วง(ห่อเล็ก)', 'พ่วง(ห่อใหญ่)'],
            update_list: {
                1: {1: '', 2: '', 3: ''},
                2: {1: '', 2: '', 3: ''},
                3: {1: '', 2: '', 3: ''},
                4: {1: '', 2: '', 3: ''},
                5: {1: '', 2: '', 3: ''},
            }
        }
    },
    created() {
        this.getCustomerTable(1);
        this.getCustomerAll();
        this.$store.dispatch("TransportType/transportTypeAll");
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            transport_type: state => {
                return state.TransportType.transport_type_all.filter(data => data.id != 4)
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            optionProvince: state => {
                return state.Common.province;
            },
            optionDistricts: state => {
                return state.Common.districts;
            },
            optionGeography: state => {
                return state.Common.geography;
            },
        }),
    },
    methods: {
        getProvince(area) {
            if (area) {
                this.$store.dispatch('Common/setProvinceFromGeography', area.id);
            } else {
                this.search.province = null;
                this.search.district = null;
            }
        },
        getDistricts(province) {
            if (province) {
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.search.district = null;
            }
        },
        showUpdateModal() {
            this.$refs.update_price_modal.show()
        },
        hideUpdateModal() {
            this.$refs.update_price_modal.hide()
        },
        submitUpdate() {
            this.showLoadingModal();
            this.$store.dispatch('Customer/updateCustomerOtherTransportPrice', this.update_list).then(() => {
                this.hideUpdateModal();
                this.hideLoadingModal();
                this.getCustomerTable(1);
            })
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showEditTransportFeeModal() {
            this.$refs.edit_sub_transport_fee.show();
        },
        hideEditTransportFeeModal() {
            this.$refs.edit_sub_transport_fee.hide();
        },
        customSaleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        showCustomerData(id) {
            this.$store.dispatch("Customer/showSub", id).then(() => {
                this.showEditTransportFeeModal();
            })
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.optionCustomer = res;
            });
        },
        onClickSearch(page) {
            this.showLoadingModal();
            this.status_loading = 1;
            this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่"
            this.getCustomerTable(page);
        },
        getCustomerTable(page) {
            let data = {
                customer_id: this.search.customer ? this.search.customer.id : '',
                sale_id: this.search.sale ? this.search.sale.id : '',
                area_id: this.search.area ? this.search.area.id : '',
                province_id: this.search.province ? this.search.province.id : '',
                districts_id: this.search.district ? this.search.district.id : '',
            }
            this.$store.dispatch("Customer/getCustomerSubTransportEdit", {
                page,
                data,
            }).then(res => {
                this.transportFoamList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.form,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                };
            }).then(() => {
                this.hideLoadingModal();
            });
        },
        saveTransportFoam(value) {
            if (value) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่"
                this.$store.dispatch("Customer/saveTransportFeeCustomerOther", value).then(() => {
                    this.getCustomerTable(this.dataPaginate.current_page);
                    this.hideLoadingModal();
                }).catch(err => {
                    //console.log(err)
                    this.status_loading = 3;
                    this.msg = "บันทึกข้อมูลไม่สำเร็จ"
                })
            }
            this.hideEditTransportFeeModal();
        },
        printTransportFoamCustomer() {
            let data = {
                sale_id: this.search.sale ? this.search.sale.sale_id : '',
            }
            window.open(`${domain}/update/log_customer_other_foam_price?seller=${data.sale_id}`)
        }
    }
}
</script>

<style scoped>
.select {
    border: 0;
}
</style>
